var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8612 10.5259L10.5258 10.8612C10.3407 11.0463 10.0405 11.0463 9.85535 10.8612L6.00001 7.00575L2.14459 10.8611C1.95947 11.0463 1.65927 11.0463 1.47412 10.8611L1.13887 10.5258C0.953711 10.3407 0.953711 10.0405 1.13887 9.85535L4.99426 6.00001L1.13887 2.14459C0.953711 1.95947 0.953711 1.65927 1.13887 1.47412L1.47411 1.13887C1.65927 0.953718 1.95947 0.953718 2.14459 1.13887L6.00001 4.99426L9.85535 1.13887C10.0405 0.953711 10.3407 0.953711 10.5258 1.13887L10.8612 1.47411C11.0463 1.65927 11.0463 1.95947 10.8612 2.14459L7.00575 6.00001L10.8612 9.85535C11.0463 10.0405 11.0463 10.3407 10.8612 10.5259Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/CloseIcon.c4c94faf03ed4b67c56a556b071ebfd3.svg";
export { ForwardRef as ReactComponent };